import { render, staticRenderFns } from "./Equalizer.vue?vue&type=template&id=1b84b828&"
import script from "./Equalizer.vue?vue&type=script&lang=js&"
export * from "./Equalizer.vue?vue&type=script&lang=js&"
import style0 from "./Equalizer.vue?vue&type=style&index=0&id=1b84b828&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports